<template>
  <div v-if="isVisible">
    <div>
      <el-select
          v-model="curSelectValue"
          size="small"
          @change="itemSelectChange"
          class="dm-select"
          style="width: 100%;"
          :multiple="isMultiple"
          :placeholder="selectTip"
      >
        <el-option
            v-for="item in itemOptions"
            :key="item.value"
            :label="item.text"
            :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <el-row style="margin-top: 3vh;">
      <!--      <el-col :span="12">
              <el-button class="dgClose" @click="itemPopSelect">筛 选</el-button>
            </el-col>-->
      <el-col :span="24">
        <el-button class="dgSave" @click="itemPopReset">重 置</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "itemSelectPop",
  props: {
    'itemOptions': {
      type: Array,
      default: () => [],
      required: false,
    },
    'isVisible': {
      type: Boolean,
      default: false,
    },
    'isMultiple': {
      type: Boolean,
      default: true,
    },
    'popTitle': {
      type: String,
      default: '',
    },
    'itemLx': {
      type: String,
      default: '',
    },
    'selectTip': {
      type: String,
      default: '请选择内容',
    },
  },
  data() {
    return {
      curSelectValue: '',
      isVisiblePop: false,
    }
  },
  methods: {
    clearAllValue(){
      this.curSelectValue='';
    },
    itemSelectChange() {
      let itemStr = '';
      if (this.isMultiple) {
        itemStr = this.curSelectValue.length > 0 ? this.curSelectValue.join(',') : '';
      } else {
        itemStr = this.curSelectValue;
      }
      let params = {
        lx: this.itemLx,
        itemStr: itemStr,
      }
      this.$emit('itemPopSelectDeal', params)
    },
    itemPopSelect() {
      // console.log("======fdafd======", this.curSelectValue);
      let itemStr = '';
      if (this.isMultiple) {
        itemStr = this.curSelectValue.length > 0 ? this.curSelectValue.join(',') : '';
      } else {
        itemStr = this.curSelectValue;
      }
      let params = {
        lx: this.itemLx,
        itemStr: itemStr,
      }
      this.$emit('itemPopSelectDeal', params)
    },
    itemPopReset() {
      this.curSelectValue = '';
      this.$emit('itemPopResetDeal', '')
    },
  },
  mounted() {
  },

}
</script>

<style scoped>
.dgClose {
  width: 8vh;
  height: 3vh;
  font-family: PingFang SC;
  font-size: 1.2vh;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vh;
  letter-spacing: 0vh;
  color: #0066ff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: solid 1px #53abfd;
  border-radius: 2px;
}

.dgSave {
  width: 8vh;
  height: 3vh;
  background-color: #53abfd;
  border-radius: 0vh;
  font-family: PingFang SC;
  font-size: 1.2vh;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vh;
  letter-spacing: 0vh;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
}
</style>
